export const getDownloadSampleInstrumentUrl = (productId, instrumentIds) => {
    const baseDlUrl = "/wt/api/main/v1/download/sample_instruments/" //<product>/<instruments>/"
    const dlUrl = [productId, instrumentIds.join(",")].join("/")
    return baseDlUrl + dlUrl
}
